import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
/**
 * Breadcrumb nav for the Gen3 E-Foot Gear product detail page.
 * Owned by this page only.
 */
export function Breadcrumb() {
  return <nav className="flex items-center gap-2 text-sm text-gray-500 mb-6" data-id="element-404">
      <a href="/" className="hover:text-gray-900" data-id="element-405">
        Home
      </a>
      <ChevronRightIcon className="w-4 h-4" data-id="element-406" />
      <a href="/shop/gen-3/" className="hover:text-gray-900" data-id="element-407">
        Gen 3
      </a>
      <ChevronRightIcon className="w-4 h-4" data-id="element-408" />
      <span className="text-gray-900 font-medium" data-id="element-409">Gen3 E-Foot Gear</span>
    </nav>;
}